import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Space,
  Modal,
  Button,
  Upload,
  UploadProps,
  message,
  Image,
  Dropdown,
  Menu
} from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import { EditOutlined, EyeOutlined, UploadOutlined } from '@ant-design/icons';
import axios from 'axios';
import env from 'utils/env';
import { getItem } from 'utils/local-storage';
import './UserImageProfile.css';

const UserImageProfile: React.FC = () => {
  const [image, setImage] = useState('');
  const [file, setFile] = useState<Blob | string>('');
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isPreviewVisible, setIsPreviewVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleOk = () => {
    if (file !== '') {
      setLoading(true);
      const token = getItem('sessionToken');
      if (!token) return;
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          'x-session-token': token
        }
      };
      const fmData = new FormData();
      fmData.append('picture', file);
      axios
        .post(`${env().userServerApiUrl}/user/api/v1/picture`, fmData, config)
        .then((res) => {
          if (typeof file === 'object') {
            const imageObjectURL = URL.createObjectURL(file);
            setImage(imageObjectURL);
          }
          setFile('');
          setFileList([]);
          setIsModalVisible(false);
          setLoading(false);
        })
        .catch((err) => {
          message.error(err.message);
          setFile('');
          setFileList([]);
          setIsModalVisible(false);
          setLoading(false);
        });
    } else {
      setIsModalVisible(false);
      setFile('');
      setFileList([]);
      setIsModalVisible(false);
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFileList([]);
    setFile('');
    setIsModalVisible(false);
  };

  const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) =>
    setFileList(newFileList);

  const handleSubmit: UploadProps['customRequest'] = (options) => {
    const { onSuccess, onProgress, onError, file } = options;
    if (typeof file === 'object' && file.size > 2000000) {
      if (onError) {
        const error = new Error(
          'The file is too big. Maximum file size is 2MB.'
        );
        onError(error);
        message.error('The file is too big. Maximum file size is 2MB.');
      }
    } else {
      if (onProgress) {
        setFile(file);
        onProgress({ percent: 50 });
      }
      if (onSuccess) {
        setTimeout(() => {
          onSuccess('ok');
        }, 1000);
      }
    }
  };

  useEffect(() => {
    const token = getItem('sessionToken');
    if (!token) return;
    axios
      .get(`${env().userServerApiUrl}/user/api/v1/picture`, {
        headers: {
          'x-session-token': token
        },
        responseType: 'blob'
      })
      .then((res) => {
        const imgBlob = res.data;
        const imageObjectURL = URL.createObjectURL(imgBlob);
        setImage(imageObjectURL);
      })
      .catch((err) => {
        console.log('error', err);
      });
  }, []);

  const menu = (
    <Menu>
      <Menu.Item onClick={() => setIsPreviewVisible(true)}>
        <Space>
          <EyeOutlined />
          Xem ảnh đại diện
        </Space>
      </Menu.Item>
      <Menu.Item onClick={() => setIsModalVisible(true)}>
        <Space>
          <EditOutlined />
          Cập nhật ảnh đại diện
        </Space>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="avatar">
      <Dropdown overlay={menu} trigger={['click']} placement="bottomCenter" arrow={true}>
        <Avatar
          size={{ xs: 35, sm: 35, md: 56, lg: 64, xl: 64, xxl: 64 }}
          src={<img src={image} alt="avatar" />}
        />
      </Dropdown>
      <Image
        style={{ display: 'none' }}
        preview={{
          visible: isPreviewVisible,
          src: image,
          onVisibleChange: (value) => {
            setIsPreviewVisible(value);
          }
        }}
      />
      <Modal
        title="Chỉnh sửa ảnh đại diện"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel} loading={loading}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleOk}
          >
            Save
          </Button>
        ]}
      >
        <Upload
          multiple={false}
          maxCount={1}
          fileList={fileList}
          listType="picture"
          accept="image/*"
          onChange={handleChange}
          customRequest={handleSubmit}
        >
          {fileList.length === 0 && (
            <Space>
              <Button icon={<UploadOutlined />}>Upload</Button>
              <h4>Upload your image</h4>
            </Space>
          )}
        </Upload>
      </Modal>
    </div>
  );
};

export default UserImageProfile;
